import './Playlist.css';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { setSelectedPlaylist } from '../store/slices/playlistSlice';
import type { ThemePlaylistData } from '../api/responses';
import { useMemo } from 'react';

export default function Playlist() {
  const dispatch = useAppDispatch();
  const themePlayList = useAppSelector(
    (state) => state.store.storeInfo?.themePlayList ?? []
  );

  // idx 기준으로 그룹핑: 11~13 → 왼쪽, 21~23 → 중간, 31~33 → 오른쪽
  const groups = useMemo(() => {
    const prefixes = [1, 2, 3] as const;
    return prefixes
      .map((prefix) => {
        const items = themePlayList
          .filter((item) => Math.floor(item.idx / 10) === prefix)
          .sort((a, b) => a.idx - b.idx);
        return items.length > 0 ? items : null;
      })
      .filter((g): g is ThemePlaylistData[] => g !== null);
  }, [themePlayList]);

  const handlePlayPlaylist = (item: ThemePlaylistData) => {
    dispatch(setSelectedPlaylist({
      id: String(item.idx),
      title: item.themeNm,
      description: item.descTxt,
      youtubePlaylistId: item.playlistUrl,
    }));
  };

  return (
    <div className="playlist-container">
      <div className="playlist-header">
        <div className="playlist-title">
          <span className="playlist-icon">🎵</span>
          <h1>YouTube Music 플레이리스트</h1>
        </div>
        <p className="playlist-subtitle">다양한 장르의 플레이리스트를 감상하세요</p>
      </div>

      {/* 이용 가이드 버튼 — 오른쪽 하단 고정 */}
      <button
        className="guide-btn"
        onClick={() => window.open('https://summitplay.notion.site/Play-Some-Tunes-34f77dadb82080a5a4edc29f483d71f4?source=copy_link', '_blank')}
      >
        이용 가이드
      </button>

      <div className="playlists-grid">
        {groups.length === 0 ? (
          <div className="playlist-empty">등록된 플레이리스트가 없습니다</div>
        ) : (
          groups.map((items) => {
            const first = items[0];
            return (
              <div key={first.idx} className="playlist-card">
                {/* 썸네일 — 그룹 첫 번째 항목의 이미지 */}
                <div className="playlist-thumbnail-wrapper">
                  <img
                    src={first.thumbnailUrl}
                    alt={first.themeNm}
                    className="playlist-thumbnail"
                  />
                </div>

                {/* 플레이리스트 정보 — 그룹 첫 번째 항목의 텍스트 */}
                <div className="playlist-info">
                  <h2 className="playlist-card-title">{first.themeNm}</h2>
                  <p className="playlist-description">{first.descTxt}</p>
                </div>

                {/* 카드 하단 — 그룹 내 각 항목을 버튼(링크)으로 표시 */}
                <div className="playlist-actions">
                  {items.map((item, i) => (
                    <button
                      key={item.idx}
                      className="btn-playlist btn-play"
                      onClick={() => handlePlayPlaylist(item)}
                    >
                      {item.themeNm} <span className="btn-seq">#{i + 1}</span>
                    </button>
                  ))}
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
